import FormItemCheckbox from '../../components/SessionComponents/ConfigContracts/FormItemCheckbox';
import FormItemDatePicker from '../../components/SessionComponents/ConfigContracts/FormItemDatePicker';
import FormItemInput from '../../components/SessionComponents/ConfigContracts/FormItemInput';
import FormItemNumber from '../../components/SessionComponents/ConfigContracts/FormItemNumber';
import { TERM_OF_CONTRACT_FIELD_TYPE } from './enums';

export const DOMAIN = process.env.REACT_APP_DOMAIN;
export const HUB_URI = process.env.REACT_APP_HUB_URI;
export const ENV_PRODUCTION = null;
export const STATUS_COLORS_LIST = [
  '#43a0c0',
  '#3969f6',
  '#8e0fc2',
  '#c617b5',
  '#d90671',
  '#cd0103',
  '#ef5d30',
  '#f3c833',
  '#7bd938',
  '#52ce9d',
];
export const DEFAULT_PAGE_SIZES = {
  xs: 10,
  sm: 20,
  md: 50,
  lg: 100,
};
export const DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZES.sm;
export const DEFAULT_PAGINATION = {
  pageable: null,
  sort: null,
  totalPages: 0,
  totalElements: 0,
  last: false,
  first: true,
  numberOfElements: 0,
  size: DEFAULT_PAGE_SIZE,
  number: 0,
  empty: null,
};
export const LANGUAGE_HASH_PARAM = 'l';
export const EMAIL_REGEX = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
export const DATE_FORMAT = 'DD/MM/YYYY';

export const TERM_ITEM_UI_TYPE = {
  [TERM_OF_CONTRACT_FIELD_TYPE.NUMBER]: FormItemNumber,
  [TERM_OF_CONTRACT_FIELD_TYPE.DATE_TIME]: FormItemDatePicker,
  [TERM_OF_CONTRACT_FIELD_TYPE.CHECK_BOX]: FormItemCheckbox,
  [TERM_OF_CONTRACT_FIELD_TYPE.FREE_TEXT]: FormItemInput,
};
